import { render, staticRenderFns } from "./couponDetails.vue?vue&type=template&id=1bd8c775&"
import script from "./couponDetails.vue?vue&type=script&lang=js&"
export * from "./couponDetails.vue?vue&type=script&lang=js&"
import style0 from "./couponDetails.vue?vue&type=style&index=0&id=1bd8c775&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports